import { connect } from "react-redux";
import { navigateTo } from "gatsby-link";
import FilterOverview from "../FilterOverview";

import {
  getFilterTags,
  setFiltered,
  setSelectedId,
  setArticleIds
} from "../../state/articles/filter";
import { showModal, modals } from "../../state/modal";

const withRedux = connect(
  state => ({
    filterTags: getFilterTags(state)
  }),
  dispatch => ({
    onSetArticles(articleIds) {
      dispatch(setArticleIds(articleIds));
    },
    onUpdateFilter(tagIds) {
      dispatch(setFiltered(tagIds));
    },
    onResetClick(e) {
      e.preventDefault();
      dispatch(setFiltered([]));
    },
    // Store the selected articleId and navigate to the article page
    onPreviewClick(e, articleId) {
      e.preventDefault();
      dispatch(setSelectedId(articleId));
      navigateTo("/filter/article/");
    },
    onDownloadClick() {
      const modal = {
        modalType: modals.DOWNLOAD_FILTERED_ARTICLES,
        modalProps: { foo: "bar" }
      };
      dispatch(showModal(modal));
    }
  })
);

export default withRedux(FilterOverview);



// WEBPACK FOOTER //
// ./src/components/FilterOverview/container.js